import {
  SAVE_PAYER_POLICY_RES,
  EDIT_PATIENT_RES,
  VISIBLE,
  PATIENT_UPDATE_STATUS,
  CREATE_INSURANCE_ADDRESS_RES,
  SAVE_PAYER_DETAILS_RESPONSE,
  SAVE_POLICY_HOLDER_DETAILS_RESPONSE,
  GET_POLICY_HOLDER_DETAILS_RESPONSE,
  SEARCH_PAYER_RES,
  SEARCH_PAYER_ADDRESS_RES,
  GET_INSURANCE_BY_VISITTYPE_RES,
  GET_INSURANCE_ACTIVE_RES,
  CHECKIN_RES,
  CANCEL_CLICK,
  SAVE_HOLDER_STATUS,
  POLICY_OBJECT,
  COLLAPSE_INDEX,
  GET_POLICIES_FOR_CHECKIN,
  GET_APPOINTMENT_LIST_RES,
  CANCEL_APPOINTMENT_LIST_RES,
} from './insurance.types'

/**
 * @fileOverview Manages the response of action
 * @author Athul George <athul@trillium-technologies.com>
 * @author  Akhil Francis <akhil@trillium-technologies.com>
 * @author Cinu James <cinu@trillium-technologies.com>
 * @example switch (action.type) {
    case TYPE_NAME: {
      return {
        ...state,
        ...{INITIAL_STATE: action.payload },
      }
    }
    }
 */
const INITIAL_STATE = {
  editPatientDetails: {},
  visible: false,
  patientUpdateStatus: false,
  payerAddressResponse:null,
  payerData: {},
  policyHolderResponse:null,
  searchpayers:null,
  payerAddressList:null,
  getInsuranceByVisitTypeData: {},
  getInsuranceActiveData: {},
  checkinData: {},
  payerPolicyRes: {},
  cancelStatus: false,
  getPolicyHolderResponse: {},
  saveHolderStatusValue: false,
  policyObject: null,
  collIndex: null,
  latestPolicies: null,
  appointmentList: {},
  appointmentCancelStatus: {},
}
/**
 *
 * @param state
 * @param action
 * @return {{editPatientDetails: {},
 * visible: boolean, getInsuranceActiveData: {},
 * checkinData: {},
 * cancelStatus: boolean,
 * payerData: {},
 * payerPolicyRes: {},
 * patientUpdateStatus: boolean,
 * createInsuranceAddress: *,
 * searchpayers: {},
 * getPolicyHolderResponse: {},
 * getInsuranceByVisitTypeData: {},
 * policyHolderResponse: {},
 * searchPayerAddressData: {},
 * saveHolderStatusValue: boolean}|{editPatientDetails: *, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: *, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: *, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: *, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: *, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: *, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: *, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: *, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: *, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: *, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: *}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, savePayerResponse: *, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: boolean, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: *, saveHolderStatusValue: boolean}|{editPatientDetails: {}, visible: *, getInsuranceActiveData: {}, checkinData: {}, cancelStatus: boolean, payerData: {}, payerPolicyRes: {}, patientUpdateStatus: boolean, createInsuranceAddress: {}, searchpayers: {}, getPolicyHolderResponse: {}, getInsuranceByVisitTypeData: {}, policyHolderResponse: {}, searchPayerAddressData: {}, saveHolderStatusValue: boolean}}
 */
const insuranceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case POLICY_OBJECT: {
      return { ...state, ...{ policyObject: action.payload } }
    }
    case SAVE_PAYER_POLICY_RES: {
      return { ...state, ...{ payerPolicyRes: action.payload } }
    }
    case SEARCH_PAYER_RES: {
      return { ...state, ...{ searchpayers: action.payload } }
    }
    case EDIT_PATIENT_RES: {
      return { ...state, ...{ editPatientDetails: action.payload } }
    }
    case VISIBLE: {
      return { ...state, ...{ visible: action.payload } }
    }
    case PATIENT_UPDATE_STATUS: {
      return { ...state, ...{ patientUpdateStatus: action.payload } }
    }
    case CREATE_INSURANCE_ADDRESS_RES: {
      return { ...state, ...{ payerAddressResponse: action.payload } }
    }
    case SAVE_PAYER_DETAILS_RESPONSE: {
      return { ...state, ...{ savePayerResponse: action.payload } }
    }
    case SAVE_POLICY_HOLDER_DETAILS_RESPONSE: {
      return { ...state, ...{ policyHolderResponse: action.payload } }
    }
    case GET_POLICY_HOLDER_DETAILS_RESPONSE: {
      return { ...state, ...{ getPolicyHolderResponse: action.payload } }
    }
    case SEARCH_PAYER_ADDRESS_RES: {
      return { ...state, ...{ payerAddressList: action.payload } }
    }
    case GET_INSURANCE_BY_VISITTYPE_RES: {
      return { ...state, ...{ getInsuranceByVisitTypeData: action.payload } }
    }
    case GET_INSURANCE_ACTIVE_RES: {
      return { ...state, ...{ getInsuranceActiveData: action.payload } }
    }
    case CHECKIN_RES: {
      return { ...state, ...{ checkinData: action.payload } }
    }
    case CANCEL_CLICK: {
      return { ...state, ...{ cancelStatus: action.payload } }
    }
    case SAVE_HOLDER_STATUS: {
      return { ...state, ...{ saveHolderStatusValue: action.payload } }
    }
    case COLLAPSE_INDEX: {
      return { ...state, ...{ collIndex: action.payload } }
    }
    case GET_POLICIES_FOR_CHECKIN: {
      return { ...state, ...{ latestPolicies: action.payload } }
    }
    case GET_APPOINTMENT_LIST_RES: {
      return { ...state, ...{ appointmentList: action.payload } }
    }
    case CANCEL_APPOINTMENT_LIST_RES: {
      return { ...state, ...{ appointmentCancelStatus: action.payload } }
    }

    default:
      return state
  }
}
export default insuranceReducer
